var map = {
	"./20250507_152312.jpg": 734,
	"./banner.jpeg": 471,
	"./botellaChipotle250ml.jpeg": 364,
	"./botellaColaGallo250ml.jpeg": 872,
	"./botellaHabanero250ml.jpeg": 370,
	"./botellaJalapeno250ml.jpeg": 424,
	"./botellasVistaFrenteEnfocada.jpeg": 565,
	"./campoHabaneroFondo.png": 140,
	"./campoHabaneroFondo2.png": 780,
	"./facebook.png": 960,
	"./figurabotellaChipotle250ml.jpeg": 36,
	"./figurabotellaColaGallo250ml.jpeg": 216,
	"./figurabotellaJalapeno250ml.jpeg": 64,
	"./figurasbotellaHabanero250ml.jpeg": 245,
	"./frascoCebolla150ml.jpg": 405,
	"./frascoPastadeChimichurri.jpeg": 834,
	"./frascosProductos.jpg": 644,
	"./home40.png": 677,
	"./home80.png": 345,
	"./instagram.png": 978,
	"./rene.jpeg": 153,
	"./tok.png": 92,
	"./whatsapp70.png": 475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 958;